import { render, staticRenderFns } from "./ExtensionUsed.vue?vue&type=template&id=31d7f176"
import script from "./ExtensionUsed.vue?vue&type=script&lang=ts"
export * from "./ExtensionUsed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports